import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { emptyArray } from 'ui-components/default-props/empty';

import style from './style.module.less';

const OverflowMeasurer = ({ children = emptyArray, onMeasured }) => {
  const actualChildrenArray = React.Children.toArray(children);
  const childRefs = useRef(children.map(() => React.createRef()));

  useEffect(() => {
    const measurements = childRefs.current.map((ref) => {
      const measurement = ref?.current?.clientWidth ?? -1;
      if (measurement !== -1) {
        const computedStyle = window.getComputedStyle(ref.current);
        const marginLeft = parseInt(computedStyle.getPropertyValue('margin-left'), 10);
        const marginRight = parseInt(computedStyle.getPropertyValue('margin-right'), 10);
        return measurement + marginLeft + marginRight;
      }

      return 0;
    });

    onMeasured(measurements);
  }, [actualChildrenArray, childRefs, onMeasured]);

  return (
    <div className={style.invisible}>
      {React.Children.map(children, (child, i) =>
        React.cloneElement(child, {
          ...child.props,
          ref: childRefs.current[i],
        }),
      )}
    </div>
  );
};

OverflowMeasurer.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  onMeasured: PropTypes.func.isRequired,
};

export default OverflowMeasurer;
